<template>
  <q-dialog
    v-model="isOpen"
    persistent
    class="confirm-modal"
  >
    <q-card
      flat
      style="min-width: 380px; max-width: 480px"
      class="confirm-modal-card lg-radius"
    >
      <q-card-section class="modal-header">
        <h6 class="text-16">{{ confirmModalData?.title }}</h6>

        <q-btn
          v-close-popup
          flat
          round
          dense
          color="brand"
          @click="handleCancel"
        >
          <lucide-icon
            name="x-icon"
            :size="20"
          />
        </q-btn>
      </q-card-section>

      <q-card-section class="modal-content">
        <div class="icon-wrapper">
          <lucide-icon
            :name="confirmModalData?.icon || 'help-circle'"
            :size="24"
            color="brand"
          />
        </div>

        <p class="text-16 text-primary">{{ confirmModalData?.message }}</p>
      </q-card-section>

      <q-card-actions class="modal-actions full-width">
        <q-btn
          v-close-popup
          :label="confirmModalData?.cancelText"
          :color="confirmModalData?.cancelColor"
          outline
          padding="0.5rem 1rem"
          class="cancel-btn"
          no-caps
          @click="handleCancel"
        />

        <template v-if="confirmModalData?.continueText">
          <q-btn
            v-close-popup
            padding="0.5rem 1rem"
            :label="confirmModalData?.continueText"
            :color="confirmModalData?.continueColor"
            no-caps
            @click="handleContinue"
          />
        </template>

        <q-btn
          v-close-popup
          :label="confirmModalData?.confirmText"
          :color="confirmModalData?.confirmColor"
          padding="0.5rem 1.5rem"
          unelevated
          no-caps
          @click="handleConfirm"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
  import { useConfirm } from 'src/composables/app/system/useConfirm'

  const { isOpen, confirmModalData, closeConfirm } = useConfirm()

  const handleConfirm = () => {
    confirmModalData.value?.onConfirm?.()
    closeConfirm()
  }

  const handleCancel = () => {
    confirmModalData.value?.onCancel?.()
    closeConfirm()
  }

  const handleContinue = () => {
    confirmModalData.value?.onContinue?.()
    closeConfirm()
  }
</script>

<style lang="scss">
  .confirm-modal {
    .confirm-modal-card {
      box-shadow: $card-shadow !important;
      overflow: hidden;
    }

    .modal-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 1.25rem;
    }

    .modal-content {
      display: flex;
      align-items: flex-start;
      gap: 1rem;
      padding: 1rem 1.25rem;

      .icon-wrapper {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      p {
        line-height: 1.4;
        flex: 1;
      }
    }

    .modal-actions {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.75rem;
      padding: 1rem 1.25rem;

      .q-btn {
        font-weight: 400 !important;
        border-radius: $input-border-radius;
        font-size: 0.875rem;
        &.cancel-btn {
          .q-btn__content {
            color: $secondary !important;
          }
        }
      }
    }
  }
</style>
